<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 16">
    <path d="M15.702 2.067h-5.36v0.992h1.58v1.57h-1.58v0.5h1.58v1.571h-1.58v0.515h1.58v1.485h-1.58v0.595h1.58v1.49h-1.58v0.595h1.58v1.498h-1.58v1.092h5.36c0.084-0.025 0.155-0.124 0.212-0.298 0.057-0.175 0.086-0.316 0.086-0.424v-11c0-0.085-0.030-0.136-0.086-0.154s-0.128-0.027-0.212-0.027zM15.007 12.877h-2.572v-1.497h2.572v1.498zM15.007 10.784h-2.572v-1.49h2.572v1.49zM15.007 8.699h-2.572v-1.479h2.572v1.48zM15.007 6.699h-2.572v-1.569h2.572v1.57zM15.007 4.619h-2.572v-1.559h2.572v1.57zM0 1.82v12.4l9.44 1.633v-15.708l-9.44 1.68zM5.595 11.2c-0.036-0.097-0.205-0.51-0.505-1.242-0.3-0.73-0.48-1.156-0.533-1.277h-0.017l-1.012 2.41-1.353-0.091 1.605-3-1.47-3 1.38-0.073 0.912 2.347h0.018l1.030-2.454 1.425-0.090-1.697 3.247 1.75 3.312-1.533-0.090z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-excel.html